
export enum PayformNoteTypeCd {
	ACTIVITY = 'Activity',
	DETOUR = 'Detour',
	PAYFORM = 'Payform',
	SCHEDULE = 'Schedule'}

